import template from './employee_view_search_component.html'
import * as Permissions from '../../lib/permission_utils.js'
import * as Utils from '../../lib/savanna_utils.js'
import tr from '../../lib/default-translator.js'

class EmployeeViewSearchComponentViewModel
{
    constructor(bindings)
    {
        this.bindings = bindings
        this.employee_records = ko.observableArray()
        this.search_string = ko.observable('')
        this.has_full_access = ko.observable(false);
        // Observable for including resigned employees
        this.include_resigned = ko.observable(false);

        this.get_employee = this.get_employee.bind(this)
        this.search_string.subscribe((value) => {
            clearTimeout(this.searchTimeout)
            this.searchTimeout = setTimeout(() => {
                this.updateData();
            }, 300) // 300ms delay
        })
        this.include_resigned.subscribe(() => {
            this.updateData();
        });
    }

    async updateData()
    {
        await this.check_access();
    }

    async init()
    {
        await this.updateData();
    }

    async load_search_data()
    {
        // Use correct table depending on toggle
        let table;
        if (this.has_full_access()) 
        {
            if (this.include_resigned()) {
                table = 'v_all_employee_data';
            } else {
                table = 'v_active_employees_department';
            }
        } else 
        {
            table = 'v_restricted_access_list';
        }
        let schema = 'savanna'

        let option = {
            table: table,
            schema: schema,
            limit: 50, // Limit results for performance
            filter_join: 'OR',
            filter: [],
        }

        if (this.search_string() && this.search_string().trim() !== '')
        {
            let search_input = this.search_string().trim()

            // Add individual field searches
            option.filter.push({
                field: 'firstname',
                operand: 'ILIKE',
                value: `%${search_input}%`,
            })

            option.filter.push({
                field: 'surname',
                operand: 'ILIKE',
                value: `%${search_input}%`,
            })

            option.filter.push({
                field: 'id_number',
                operand: 'ILIKE',
                value: `%${search_input}%`,
            })

            option.filter.push({
                field: 'employee_code',
                operand: 'ILIKE',
                value: `%${search_input}%`,
            })

            if (table === 'v_all_employee_data') {
                option.filter.push({
                    field: 'search_text',
                    operand: 'ILIKE',
                    value: `%${search_input}%`,
                })
            }

            let result = await Grape.fetches.getJSON('/api/record', option)
            if (result.status != 'ERROR')
            {
                if (result.records != null) 
                    this.employee_records(result.records)
            }
        }
        else 
            this.employee_records([])
    }

    get_employee(data)
    {
        this.employee_records([])
        this.search_string('') // Clear search
        Grape.navigate('/employee/view/' + data.employee_id)
    }

    async check_access()
    {
        try
        {
            let full_access = await Permissions.checkAccessRights('ViewEmployeeListFull');
            if (full_access)
            {
                this.has_full_access(true);
                await this.load_search_data();
            }
            else
            {
                let partial_access = await Permissions.checkAccessRights('ViewEmployeeListPartial');
                if (partial_access)
                {
                    this.has_full_access(false);
                    await this.load_search_data();
                }
            }
        }
        catch (error)
        {
            console.error('Error checking access rights:', error)
        }
    }

    // Cleanup method
    dispose()
    {
        if (this.searchTimeout) 
            clearTimeout(this.searchTimeout)
    }
}

export default {
    name: 'employee_view_search_component',
    viewModel: EmployeeViewSearchComponentViewModel,
    module_type: 'ko',
    template: template,
    template_filename: 'translation/components/employee_view_search_component',
}
